if (!customElements.get('ensemble-product-options')) {
  class EnsembleProductOptions extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.status = this.querySelector('[data-ensemble-status]');
      this.submitButton = this.form?.querySelector('[name="add"]');

      this.addEventListener('change', this.updateCompletionState.bind(this));
      this.updateCompletionState();
    }

    updateCompletionState() {
      const requiredInputs = [...this.querySelectorAll('input[required]')];
      const isComplete = requiredInputs.length > 0 && requiredInputs.every((input) => input.checkValidity());

      this.toggleAttribute('data-complete', isComplete);

      if (this.status) {
        this.status.hidden = isComplete;
      }

      if (this.submitButton) {
        this.submitButton.classList.toggle('kuden-ensemble-submit--incomplete', !isComplete);
      }
    }
  }

  customElements.define('ensemble-product-options', EnsembleProductOptions);
}

